<template style="background-color: #2c3e50">
  <div id="app">
    <img alt="EPOCH LOGO" src="http://www.110c.net/yun.png" style="padding-bottom: 2vh">

    <router-view />
<!--    <HelloWorld msg=""/>-->
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 2vh;
  background-color: #2c3e50;
  height: 100vh;
  width: 100vw;
}
</style>
